<template>
  <div :class="`cookie-banner ${accepted && !acceptComplete ? 'hiding' : ''}`" v-show="bannerShouldShow" v-scroll="handleScroll">
    <div class="inner is-beige is-tablet-regular">
      <!--<v-runtime-template :template="descriptionTemplate"></v-runtime-template>-->
      <div><span v-html="descriptionTemplate"></span><router-link title="Privacy Policy" class="underline link is-beige" to="/privacy-policy/">privacy policy</router-link>.</div>
      <button class="is-tablet-bold is-beige" @click="accept"><span class="underlined-link beige-to-red">I Agree</span></button>
    </div>
  </div>
</template>

<script>
//import slugify from 'slugify'
//import VRuntimeTemplate from "v-runtime-template"
export default {
  data() {
    return {
      accepted: false,
      acceptComplete: false,
      descriptionTemplate: `By using our website, you agree to our `
    }
  },
  components: {
    //VRuntimeTemplate
  },
  computed: {
    bannerShouldShow() {
      if(this.wasAccepted || this.acceptComplete) return false
      return true
    },
    wasAccepted() {
      return this.$cookies && this.$cookies.get('cookies-consent') === 'accepted'
    },
    config() {
      return this.$store.state.config ? this.$store.state.config['cookie-banner'] : null
    }
  },
  methods: {
    accept() {
      this.accepted = true;
      setTimeout(() => {
        this.acceptComplete = true
      }, 500);
      if(this.$cookies) {
        //this.$cookies.set('cookies-consent') === ''
        this.$cookies.set('cookies-consent', 'accepted', {
          expires: new Date(new Date().getTime() + 3600 * 24 * 7 * 365 * 10),
          path: '/'
        })
      }
    },
    handleScroll() {
      if(this.wasAccepted) return
      else {
        const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;
        if(scrollElement.scrollTop > 200) {
          this.accept()
        }
      }
    }
  }
}
</script>